<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="primary"
            dark
            flat
            >
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-navigation-drawer
        v-model="drawer"
        app
        dark
        clipped
        left
        src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
        >
            <v-list>
                <v-list-item
                v-for="([icon, text, link], i) in links"
                :key="i"
                link
                @click="goToTab(link)"
                >
                <v-list-item-icon>
                    <v-icon>{{ icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ text }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-main>
            <v-card tile>
                <v-tabs
                v-model="tab"
                background-color="primary"
                dark
                center-active
                show-arrows
                fixed-tabs
                id="stabs"
                >
                    <v-tab>Property Info</v-tab>
                    <v-tab>Property Data</v-tab>
                    <v-tab>Contacts</v-tab>
                    <v-tab>Lease Information</v-tab>
                    <v-tab>Notes/Comments</v-tab>
                    <v-tab>Images</v-tab>
                    <v-tab>Files</v-tab>
                    <v-tab>Tasks</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card class="property-info">
                            <v-card-text>
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        class="py-3"
                                        v-if="form.image != null"
                                    >
                                        <a :href="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${form.image.file}`" target="_blank" v-if="form.image.file">
                                            <v-img
                                                :src="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${form.image.file}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                width="600"
                                                height="400"
                                            >
                                                <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>                                
                                        </a>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="8"
                                    >
                                        <v-list class="transparent d-flex flex-wrap pb-0">
                                            <v-list-item
                                            >
                                                <v-list-item-title>Address</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ form.street_address + ' ' + form.city + ', ' + form.state + ' ' + form.zip }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Owner</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{  form.owner }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Building Type</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ buildingType }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>SQFT</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ form.sqft }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Acres</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ form.acres }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Year Purchased</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ form.year_purchased }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Year Built</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ form.year_built }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Purchased Price</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ form.purchased_price | currency }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Construction Type</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ constructionType }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                            <v-list-item
                                            >
                                                <v-list-item-title>Roof Type</v-list-item-title>

                                                <v-list-item-subtitle class="text-right">
                                                    {{ roofType }}
                                                </v-list-item-subtitle>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                                <v-tabs
                                v-model="tab2"
                                background-color="primary"
                                dark
                                center-active
                                show-arrows
                                fixed-tabs
                                >
                                    <v-tab>Contacts</v-tab>
                                    <v-tab>Lease Information</v-tab>
                                    <v-tab>Notes/Comments</v-tab>
                                    <v-tab>Images</v-tab>
                                    <v-tab>Files</v-tab>
                                    <v-tab>Tasks</v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="tab2">
                                    <v-tab-item>
                                        <Contacts :property="form.id" />
                                    </v-tab-item>
                                    <v-tab-item>
                                        <Lease :property="form.id" />
                                    </v-tab-item>
                                    <v-tab-item>                
                                        <Comment v-for="(comment, index) in form.comments" :key="index" :item="comment"/>
                                        <v-divider></v-divider>
                                        <v-card flat tile class="comment-form" color="accent">
                                            <v-card-text>
                                                <v-form ref="commentform">
                                                    <v-textarea
                                                        outlined
                                                        ref="comment"
                                                        v-model="comment.comment"
                                                        label="Comment"    
                                                        hide-details
                                                        auto-grow
                                                        rows="1" 
                                                        dark                       
                                                    ></v-textarea>
                                                </v-form>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions class="admin-action">
                                                <v-spacer></v-spacer>
                                                <v-btn large min-width="100%" color="primary" tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions> 
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat tile color="accent">
                                            <v-card-text>
                                                <file-pond
                                                    name="filepond"
                                                    ref="filepond"
                                                    label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                                    v-bind:allow-multiple="true"
                                                    accepted-file-types="image/*"
                                                    :server="{
                                                        url: 'https://appapi.commercialpropertiesinc.net/api/uploads/property?id='+form.id+'&type=image',
                                                        process: {
                                                            headers: {
                                                                'Authorization': `Bearer ${token}`
                                                            }
                                                        },
                                                        revert: {
                                                            headers: {
                                                                'Authorization': `Bearer ${token}`
                                                            },
                                                        }
                                                    }"
                                                    v-bind:files="files"
                                                    v-on:init="handleFilePondInit"
                                                    v-on:processfile="handleFilePondProcessfile"
                                                    v-on:processfilerevert="handleFilePondRevertfile"/>
                                            </v-card-text>
                                        </v-card>
                                        <v-card flat tile class="mx-auto overflow-hidden">
                                            <v-data-table
                                            :headers="headers"
                                            :items="form.images"
                                            class="elevation-0"
                                            item-key="id"
                                            :loading="loading"
                                            >
                                                <template v-slot:item.actions="{ item }">
                                                    <v-btn small depressed color="orange" tile @click="makeFeatured(item.id)" v-if="item.featured != true">      
                                                        <v-icon
                                                        color="white"
                                                        small
                                                        >
                                                        mdi-star-circle-outline
                                                        </v-icon>
                                                    </v-btn>  
                                                    <v-btn small depressed color="secondary" tile :href='`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${item.file}`' target="_blank">      
                                                        <v-icon
                                                        color="white"
                                                        small
                                                        >
                                                        mdi-eye
                                                        </v-icon>
                                                    </v-btn>  
                                                    <v-btn small depressed color="primary" tile @click="deleteItem(item)">                  
                                                        <v-icon
                                                        small
                                                        >
                                                        mdi-delete
                                                        </v-icon>  
                                                    </v-btn>  
                                                </template>
                                                <template v-slot:item.file_name="props">
                                                    <a :href="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`" target="_blank">
                                                        <v-img
                                                            :src="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`"
                                                            aspect-ratio="1"
                                                            class="grey lighten-2"
                                                            width="100"
                                                            height="100"
                                                        >
                                                            <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                    indeterminate
                                                                    color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                            </template>
                                                        </v-img>                                
                                                    </a>
                                                </template>
                                                <template v-slot:item.user="props">
                                                    {{ props.item.user.name }}
                                                </template>
                                            </v-data-table>
                                            <v-dialog v-model="dialogDelete" max-width="500px">
                                                <v-card color="red">
                                                    <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                                                    <v-card-actions class="red darken-4">
                                                    <v-spacer></v-spacer>
                                                    <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                                    <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                                    <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat tile color="accent">
                                            <v-card-text>
                                                <file-pond
                                                    name="filepond"
                                                    ref="filepond"
                                                    label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                                    v-bind:allow-multiple="true"
                                                    accepted-file-types="image/*,application/*"
                                                    :server="{
                                                        url: 'https://appapi.commercialpropertiesinc.net/api/uploads/property?id='+form.id+'&type=file',
                                                        process: {
                                                            headers: {
                                                                'Authorization': `Bearer ${token}`
                                                            }
                                                        },
                                                        revert: {
                                                            headers: {
                                                                'Authorization': `Bearer ${token}`
                                                            },
                                                        }
                                                    }"
                                                    v-bind:files="files"
                                                    v-on:init="handleFilePondInit"
                                                    v-on:processfile="handleFilePondProcessfile"
                                                    v-on:processfilerevert="handleFilePondRevertfile"/>
                                            </v-card-text>
                                        </v-card>
                                        <v-card flat tile class="mx-auto overflow-hidden">
                                            <v-data-table
                                            :headers="headers"
                                            :items="form.files"
                                            class="elevation-0"
                                            item-key="id"
                                            :loading="loading"
                                            >
                                                <template v-slot:item.actions="{ item }">
                                                    <v-btn small depressed color="secondary" tile :href='`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${item.file}`' target="_blank">      
                                                        <v-icon
                                                        color="white"
                                                        small
                                                        >
                                                        mdi-eye
                                                        </v-icon>
                                                    </v-btn>  
                                                    <v-btn small depressed color="primary" tile @click="deleteItem(item)">                  
                                                        <v-icon
                                                        small
                                                        >
                                                        mdi-delete
                                                        </v-icon>  
                                                    </v-btn>  
                                                </template>
                                                <template v-slot:item.file_name="props">
                                                    <a :href="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`" target="_blank">{{ props.item.file_name }}</a>
                                                </template>
                                                <template v-slot:item.user="props">
                                                    {{ props.item.user.name }}
                                                </template>
                                            </v-data-table>
                                            <v-dialog v-model="dialogDelete" max-width="500px">
                                                <v-card color="red">
                                                    <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                                                    <v-card-actions class="red darken-4">
                                                    <v-spacer></v-spacer>
                                                    <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                                    <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                                    <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <Tasks :property="form.id" />
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat tile color="accent">
                            <v-card-text class="pa-0">
                                <ValidationObserver ref="observer1">
                                    <v-form ref="personalform">
                                        <v-list flat color="accent" class="py-0">
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Property ID</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Property ID" rules="required">
                                                        <v-text-field
                                                        v-model="form.property_id"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Owner</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Owner" rules="required">
                                                        <v-text-field
                                                        v-model="form.owner"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Street Address</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                        <v-text-field
                                                        v-model="form.street_address"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">City</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                        <v-text-field
                                                        v-model="form.city"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">ZIP Code</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                        <v-text-field
                                                        v-model="form.zip"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">State</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                                        <v-autocomplete
                                                            :items="states"
                                                            :error-messages="errors"
                                                            v-model="form.state"
                                                            item-text="label"
                                                            item-value="value"
                                                            color="white"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Building Type</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Building Type" rules="required">
                                                        <v-autocomplete
                                                            :items="building_types"
                                                            :error-messages="errors"
                                                            v-model="form.building_type"
                                                            color="white"
                                                            item-text="label"
                                                            item-value="value"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">SQFT</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="SQFT" rules="required">
                                                        <v-text-field
                                                        v-model="form.sqft"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Acres</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Acres" rules="required">
                                                        <v-text-field
                                                        v-model="form.acres"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Year Purchased</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Year Purchased" rules="required">
                                                        <v-autocomplete
                                                            :items="years"
                                                            :error-messages="errors"
                                                            v-model="form.year_purchased"
                                                            color="white"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Purchased Price</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Purchased Price" rules="required">
                                                        <v-text-field
                                                        v-model="form.purchased_price"
                                                        :error-messages="errors"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Construction Type</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Construction Type" rules="required">
                                                        <v-autocomplete
                                                            :items="construction_types"
                                                            :error-messages="errors"
                                                            v-model="form.construction_type"
                                                            color="white"
                                                            item-text="label"
                                                            item-value="value"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Roof Type</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Roof Type" rules="required">
                                                        <v-autocomplete
                                                            :items="roof_types"
                                                            :error-messages="errors"
                                                            v-model="form.roof_type"
                                                            color="white"
                                                            item-text="label"
                                                            item-value="value"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Year Built</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Year Built" rules="required">
                                                        <v-autocomplete
                                                            :items="years"
                                                            :error-messages="errors"
                                                            v-model="form.year_built"
                                                            color="white"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Status</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                                        <v-select
                                                            :items="statuses"
                                                            :error-messages="errors"
                                                            v-model="form.status"
                                                            color="white"
                                                            item-text="label"
                                                            item-value="value"
                                                            required
                                                            solo
                                                            flat
                                                            dark
                                                        ></v-select>
                                                    </ValidationProvider>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-50">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Position/Order</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                        <v-text-field
                                                        v-model="form.position"
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-text-field>
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-100">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Capital Improvement</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-textarea
                                                        v-model="form.capital_improvement"
                                                        required
                                                        solo
                                                        dark
                                                        flat
                                                    ></v-textarea> 
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item class="form-row w-100">
                                                <v-list-item-content class="label">
                                                    <v-list-item-title class="font-weight-bold">Notes</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-textarea
                                                        v-model="form.notes"
                                                        required
                                                        solo
                                                        dark
                                                        flat
                                                    ></v-textarea> 
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-form>
                                </ValidationObserver>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn large min-width="50%" color="white"  to="/compliments" text tile depressed>Cancel</v-btn>                           
                                <v-btn large min-width="50%" color="primary"  @click="submit" :loading="loading" tile depressed>Update</v-btn>
                            </v-card-actions>  
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <Contacts :property="id" />
                    </v-tab-item>
                    <v-tab-item>
                        <Lease :property="id" />
                    </v-tab-item>
                    <v-tab-item>                
                        <Comment v-for="(comment, index) in form.comments" :key="index" :item="comment"/>
                        <v-divider></v-divider>
                        <v-card flat tile class="comment-form" color="accent">
                            <v-card-text>
                                <v-form ref="commentform">
                                    <v-textarea
                                        outlined
                                        ref="comment"
                                        v-model="comment.comment"
                                        label="Comment"    
                                        hide-details
                                        auto-grow
                                        rows="1" 
                                        dark                       
                                    ></v-textarea>
                                </v-form>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions class="admin-action">
                                <v-spacer></v-spacer>
                                <v-btn large min-width="100%" color="primary" tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions> 
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat tile color="accent">
                            <v-card-text>
                                <file-pond
                                    name="filepond"
                                    ref="filepond"
                                    label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                    v-bind:allow-multiple="true"
                                    accepted-file-types="image/*"
                                    :server="{
                                        url: 'https://appapi.commercialpropertiesinc.net/api/uploads/property?id='+id+'&type=image',
                                        process: {
                                            headers: {
                                                'Authorization': `Bearer ${token}`
                                            }
                                        },
                                        revert: {
                                            headers: {
                                                'Authorization': `Bearer ${token}`
                                            },
                                        }
                                    }"
                                    v-bind:files="files"
                                    v-on:init="handleFilePondInit"
                                    v-on:processfile="handleFilePondProcessfile"
                                    v-on:processfilerevert="handleFilePondRevertfile"/>
                            </v-card-text>
                        </v-card>
                        <v-card flat tile class="mx-auto overflow-hidden">
                            <v-data-table
                            :headers="headers"
                            :items="form.images"
                            class="elevation-0"
                            item-key="id"
                            :loading="loading"
                            >
                                <template v-slot:item.actions="{ item }">
                                    <v-btn small depressed color="orange" tile @click="makeFeatured(item.id)" v-if="item.featured != true">      
                                        <v-icon
                                        color="white"
                                        small
                                        >
                                        mdi-star-circle-outline
                                        </v-icon>
                                    </v-btn>  
                                    <v-btn small depressed color="secondary" tile :href='`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${item.file}`' target="_blank">      
                                        <v-icon
                                        color="white"
                                        small
                                        >
                                        mdi-eye
                                        </v-icon>
                                    </v-btn>  
                                    <v-btn small depressed color="primary" tile @click="deleteItem(item)">                  
                                        <v-icon
                                        small
                                        >
                                        mdi-delete
                                        </v-icon>  
                                    </v-btn>  
                                </template>
                                <template v-slot:item.file_name="props">
                                    <a :href="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`" target="_blank">
                                        <v-img
                                            :src="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`"
                                            aspect-ratio="1"
                                            class="grey lighten-2"
                                            width="100"
                                            height="100"
                                        >
                                            <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                    <v-progress-circular
                                                    indeterminate
                                                    color="grey lighten-5"
                                                    ></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>                                
                                    </a>
                                </template>
                                <template v-slot:item.user="props">
                                    {{ props.item.user.name }}
                                </template>
                            </v-data-table>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card color="red">
                                    <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                                    <v-card-actions class="red darken-4">
                                    <v-spacer></v-spacer>
                                    <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                    <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat tile color="accent">
                            <v-card-text>
                                <file-pond
                                    name="filepond"
                                    ref="filepond"
                                    label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                    v-bind:allow-multiple="true"
                                    accepted-file-types="image/*,application/*"
                                    :server="{
                                        url: 'https://appapi.commercialpropertiesinc.net/api/uploads/property?id='+id+'&type=file',
                                        process: {
                                            headers: {
                                                'Authorization': `Bearer ${token}`
                                            }
                                        },
                                        revert: {
                                            headers: {
                                                'Authorization': `Bearer ${token}`
                                            },
                                        }
                                    }"
                                    v-bind:files="files"
                                    v-on:init="handleFilePondInit"
                                    v-on:processfile="handleFilePondProcessfile"
                                    v-on:processfilerevert="handleFilePondRevertfile"/>
                            </v-card-text>
                        </v-card>
                        <v-card flat tile class="mx-auto overflow-hidden">
                            <v-data-table
                            :headers="headers"
                            :items="form.files"
                            class="elevation-0"
                            item-key="id"
                            :loading="loading"
                            >
                                <template v-slot:item.actions="{ item }">
                                    <v-btn small depressed color="secondary" tile :href='`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${item.file}`' target="_blank">      
                                        <v-icon
                                        color="white"
                                        small
                                        >
                                        mdi-eye
                                        </v-icon>
                                    </v-btn>  
                                    <v-btn small depressed color="primary" tile @click="deleteItem(item)">                  
                                        <v-icon
                                        small
                                        >
                                        mdi-delete
                                        </v-icon>  
                                    </v-btn>  
                                </template>
                                <template v-slot:item.file_name="props">
                                    <a :href="`https://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`" target="_blank">{{ props.item.file_name }}</a>
                                </template>
                                <template v-slot:item.user="props">
                                    {{ props.item.user.name }}
                                </template>
                            </v-data-table>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card color="red">
                                    <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                                    <v-card-actions class="red darken-4">
                                    <v-spacer></v-spacer>
                                    <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                    <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <Tasks :property="id" />
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-main>
    </v-container>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, setInteractionMode } from 'vee-validate'
import axios from 'axios'
import TokenService from '../../services/storage.service'
import Comment from '../../components/Comment.vue'
import Contacts from '../../components/Contacts.vue'
import Lease from '../../components/Lease.vue'
import Tasks from '../../components/Tasks.vue'
import mixin from '../../mixin/main.js'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    mixins: [mixin],
    props: ['id'],
    data () {
        return {
            drawer: false,
            cSizes: [
                [320, 1], 
                [764, 2], 
                [1199, 4]
            ],
            links: [
                ['mdi-application-edit', 'Property Info', 0],
                ['mdi-application-edit', 'Property Details', 1],
                ['mdi-account-supervisor', 'Contacts', 2],
                ['mdi-alert-decagram', 'Lease Info', 3],
                ['mdi-comment-text-outline', 'Notes/Comments', 4],
                ['mdi-image-multiple-outline', 'Images', 5],
                ['mdi-file-document-outline', 'Files', 6],
                ['mdi-format-list-checkbox', 'Tasks', 7],
            ],
            form: {
                property_id: '',
                owner: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                building_type: '',
                sqft: '',
                acres: '',
                year_purchased: '',
                purchased_price: '',
                construction_type: '',
                roof_type: '',
                year_built: '',
                status: '',
                capital_improvement: '',
                notes: '',
                county: '',
                user: [],
                comments: [],
                files: [],
                images: [],
                position: ''
            },
            yesno: [
                { label: 'Yes', value: 1},
                { label: 'No', value: 0}
            ],
            loading: false,
            voptions: {
                toolbar: true,
                url: 'data-source'
            },
            requiredValue: true,
            files: [],
            tab: null,
            tab2: null,
            comment: {
                comment: '',
            },
            token: '',
            headers: [
                { text: 'File', value: 'file_name', sortable: false },
                { text: 'Added By', value: 'user', sortable: false },
                { text: 'Created At', value: 'created_at', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
            ],
            dialogDelete: false,
            editedItem: {
                id: '',
            },
            defaultItem: {
                id: '',
            }
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.getProperty()
        this.token = TokenService.getToken()
    },
    computed: {
        ...mapGetters({
            building_types: 'data/building_types',
            construction_types: 'data/construction_types',
            roof_types: 'data/roof_types',
            statuses: 'data/statuses',
            states: 'data/states'
        }),
        pageTitle() {
            if(this.tab != null) {
                return this.links[this.tab][1]
            } else {
                return ''
            }
        },
        buildingType() {
            let bt = this.building_types.filter( bti => {
                return bti.value == this.form.building_type
            })

            if(bt.length) {
                return bt[0].label
            } else {
                return ''
            }
        },
        constructionType() {
            let ct = this.construction_types.filter( cti => {
                return cti.value == this.form.construction_type
            })

            if(ct.length) {
                return ct[0].label
            } else {
                return ''
            }
        },
        roofType() {
            let rt = this.roof_types.filter( rti => {
                return rti.value == this.form.roof_type
            })

            if(rt.length) {
                return rt[0].label
            } else {
                return ''
            }
        },
    },
    components: {
        ValidationObserver,
        Comment,
        Contacts,
        Lease,
        Tasks
    },
    methods: {
        ...mapActions({
            updateProperty: 'data/updateProperty',
            addComment: 'data/addPropertyComment'
        }),
        getProperty() {
            if(this.id) {
                this.loading = true
                axios.get('properties/' + this.id)
                    .then(response => {
                        this.loading = false
                        this.form = response.data
                        this.$nextTick()
                    })
            }
        },
        makeFeatured(id) {
            this.loading = true
            axios.post('uploads/featured', { id: id})
                .then(() => {
                    this.loading = false
                    this.getProperty()
                    this.$nextTick()
                })
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateProperty(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: '/properties' })
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
            }
        },
        async sendComment() {
            this.loading = true
            this.addComment({
                id: this.id, 
                comment: this.comment.comment,
            }).then(response => {
                this.loading = false
                this.form.comments.push(response)
                this.comment.comment = ''
                this.comment.parent = null
                this.$store.commit('SET_SNACKTYPE', 'green')
                this.$store.commit('SET_SNACK', 'Successfully saved')
            }).catch(() => {
                this.loading = false
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
            })
        },
        handleFilePondProcessfile: function () {
            this.getProperty();
            this.$nextTick()
        },
        handleFilePondRevertfile: function () {
            this.getProperty();
            this.$nextTick()
        },
        deleteItem (item) {
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteItemConfirm () {
            this.loading = true
            axios.delete('uploads/property_by_id?id=' + this.editedItem.id)
                .then(() => {
                    this.closeDelete()
                    this.getProperty()
                    this.$nextTick()
                })
        },
        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
            })
        },
        goToTab(link) {
            this.tab = link

            if(this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm') {
                this.drawer = false
            }
        }
    }
}
</script>

<style lang="sass">
#stabs 
    .v-tabs-bar
        display: none
</style>
<style>
.property-info .v-list-item {
    border: 1px solid #eee;
}
@media only screen and (min-width: 1000px) {
    .w-50 {
        width: 50%;
        float: left;
    }
    .property-info .v-list-item {
        max-width: 50%;
    }
}
</style>